import {
  trackJobInfoClickEvent,
  trackViewAdClickEvent,
  trackEditAdClickEvent,
  trackViewJobAdInformationClickEvent,
  trackRefreshAdClickEvent,
  trackExpireAdClickEvent,
  trackCopyAdClickEvent,
  trackExportToCsvClickEvent,
  trackTalentSearchLinkOutClickEvent,
} from 'src/utils/events';
import {
  EVENT_NAME_VIEW_JOB_DETAILS_ACTIVE_JOB_PRESSED,
  EVENT_NAME_VIEW_JOB_DETAILS_INACTIVE_JOB_PRESSED,
} from '../../../constants/pageTrackingData';
import type { IJob } from '../../../stores/JobStore/Job';
import { navigateToUrl } from './utils';

import type { Router } from 'src/constants/urls';

export enum JobAction {
  VIEW = 'view',
  TALENT_SEARCH = 'talentSearch',
  VIEW_AD_INFORMATION = 'viewAdInformation',
  EDIT = 'edit',
  SHARE = 'share',
  EXPORT_CANDIDATE_LIST = 'exportCandidateList',
  REFRESH = 'refresh',
  COPY = 'copy',
  EXPIRE = 'expire',
  NOTIFICATION_PREFERENCE = 'notificationPreference',
  TEAM_MEMBER_ACCESS = 'teamMemberAccess',
}

export const getNumberOfApplicationsInBucket = (job: IJob) =>
  job.jobApplicationStore.currentTotalOfJobApplications;

const viewJobAd = (job: IJob, router: Router) => {
  trackJobInfoClickEvent(
    job.isActive
      ? EVENT_NAME_VIEW_JOB_DETAILS_ACTIVE_JOB_PRESSED
      : EVENT_NAME_VIEW_JOB_DETAILS_INACTIVE_JOB_PRESSED,
    job.jobInformation.jobId ?? undefined,
  );
  trackViewAdClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
  navigateToUrl(
    router.viewJobAd({
      jobStatus: job.jobInformation.status,
      jobId: job.jobInformation.jobId ?? 0,
    }),
    true,
  );
};

const viewJobAdInformation = (job: IJob) => {
  trackViewJobAdInformationClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
};

const editJobAd = (job: IJob, router: Router) => {
  trackEditAdClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
  navigateToUrl(router.editJobAd({ jobId: job.jobInformation.jobId ?? 0 }));
};
const exportCandidateList = (job: IJob) => {
  trackExportToCsvClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
  job.exportToCsv();
};

const refreshJobAd = (job: IJob, router: Router) => {
  trackRefreshAdClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
  navigateToUrl(router.refreshJobAd({ jobId: job.jobInformation.jobId ?? 0 }));
};

const copyJobAd = (job: IJob, router: Router) => {
  trackCopyAdClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
  navigateToUrl(router.copyJobAd({ jobId: job.jobInformation.jobId ?? 0 }));
};

const expireJobAd = (job: IJob) => {
  trackExpireAdClickEvent({
    prospectInBucketCount: getNumberOfApplicationsInBucket(job),
  });
};

const trackTalentSearchExitLinkClick = () => {
  trackTalentSearchLinkOutClickEvent({
    isExitLink: '1',
  });
};

export const triggerJobAction = (
  jobAction: JobAction,
  job: IJob,
  router: Router,
) => {
  const actionMapper: Record<JobAction, (job: IJob, router: Router) => void> = {
    [JobAction.VIEW]: viewJobAd,
    [JobAction.TALENT_SEARCH]: trackTalentSearchExitLinkClick,
    [JobAction.VIEW_AD_INFORMATION]: viewJobAdInformation,
    [JobAction.EDIT]: editJobAd,
    [JobAction.EXPORT_CANDIDATE_LIST]: exportCandidateList,
    [JobAction.REFRESH]: refreshJobAd,
    [JobAction.COPY]: copyJobAd,
    [JobAction.EXPIRE]: expireJobAd,
    [JobAction.NOTIFICATION_PREFERENCE]: () => {},
    [JobAction.TEAM_MEMBER_ACCESS]: () => {},
    [JobAction.SHARE]: () => {
      // no action required
    },
  };
  const action = actionMapper[jobAction];
  action(job, router);
};
